import React from "react";
import Icon from './Icon';

export default class Download extends React.PureComponent {
    render() {
        return (
            <Icon className={'download'} img={require('../../../assets/images/icons/download.svg')}/>
        );
    }
}
